import { Update } from "../components/industry-conversion/Update";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/*
業態変換登録
 */
const IndustryConversionUpdate = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);

  return (
    <SpaceBetween size="l">
      <Update />
    </SpaceBetween>
  );
};

export default IndustryConversionUpdate;
